import React from 'react'
import styled from 'styled-components'
import camera_ico from '../../img/camera.jpg'
import { Cross } from './Cross'

const PicContainer = styled.div`
    width: 125px;
    height: 125px;

    background: white url(${props => props.url}) no-repeat 50% 50%;
    background-size: contain;

    cursor: pointer;

    @media (max-width: 560px) {
        width: 80px;
        height: 80px;
        :not(:last-child) {
            margin-right: 1rem;
        }

    }
    @media (max-width: 380px) {
        width: 64px;
        height: 64px;
    }
`

export function PhotoInput({ picture, setPicture }) {
    return (
        <div className="photo-input">
            <label>
                { !picture || (picture[0] === '') ? <PicContainer url={camera_ico} /> : null }
                { picture && picture.url === undefined && picture[0] !== '' ? <PicContainer url={URL.createObjectURL(picture)} /> : null }
                { picture && picture.url ? <PicContainer url={picture.url} /> : null }

                <input id='picture-input' type="file" onChange={(e) => setPicture( e.target.files[0] ) } />
            </label>
            { picture && picture[0] !== '' ? <div onClick={ ()=> setPicture(false) } ><Cross lighten /></div> : null }
        </div>
    )
}
